import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/components/home.vue'
import Wellcome from '@/components/wellcome.vue'
import ViewMaterial from '@/view/ViewMaterial.vue'
import Login from '@/components/login/login.vue'
import ChangePWD from '@/components/ChangePWD/ChangePWD.vue'
import stuffInformation from '@/view/stuffInformation.vue'
import costInformation from '@/view/costInformation.vue'
import freightClassification from '@/view/freightClassification.vue'
import correspondent from '@/view/correspondent.vue'
import operationControl from '@/view/operationControl.vue'
import orderManagement from '@/view/orderManagement.vue'
import dictionaryType from '@/view/dictionaryType.vue'
import dictionaryData from '@/view/dictionaryData.vue'
import addDetail from '@/view/addDetail.vue'
import financialManagement from '@/view/financialManagement.vue'
import invoiceRequest from '@/view/invoiceRequest.vue'
import useFund from '@/view/useFund.vue'
import expenseTemplates from '@/view/expenseTemplates.vue'
import collectionLedger from '@/view/collectionLedger.vue'
import customerReport from '@/view/customerReport.vue'
import preview from '@/components/preview.vue'
import exchangeRate from '@/view/exchangeRate.vue'
import doubleStarReport from '@/view/doubleStar.vue'
import unDeliveryReport from '@/view/unDeliveryReport.vue'
import singleBillReport from '@/view/singleBillReport.vue'
import singleContainerReport from '@/view/singleContainerReport.vue'
import containerFee from '@/view/containerFee.vue'
import home from '@/view/home.vue'
// 引入加载条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// 配置
NProgress.inc()
NProgress.configure({
    easing: 'ease',  // 动画方式    
    speed: 800,  // 递增进度条的速度    
    showSpinner: false, // 是否显示加载ico    
    trickleSpeed: 200, // 自动递增间隔    
    minimum: 0.1 // 初始化时的最小百分比
})

Vue.use(VueRouter)

// 所有人都可以访问
const routes = [
    // { path: '/home', redirect: '/home1', name: 'home1',component: Home1, meta: {title: '登录页'}},
    // { path: '/login', name: 'login', component: Login },
    { path: '/', redirect: '/login' },
    { path: '/login',   component: Login },
    { path: '/preview', component: preview},
    // { path: '/', redirect: '/home' },
    // 访问home时，重定向到wellcome页
    { path: '/changePWD', name: 'changePWD', component: ChangePWD, meta: { title: '修改密码' } },
    { path: '/addDetail', name: 'addDetail', component: addDetail, meta: {title: '增加详情'}},
    {
        path: '/home', name: 'home', component: Home,  meta: { title: '首页' },
        children: [
            { path: '/wellcome', name: 'wellcome', component: Wellcome, meta: { title: '首页' } },
            { path: '/home', name: 'home', component: home, meta: { title: '首页' } },
            { path: '/viewMaterial', name: 'viewMaterial', component: ViewMaterial, meta: { title: '基础资料' },},
            { path: '/costInformation', name: 'costInformation', component: costInformation, meta: { title: '费用信息' } },
            { path: '/stuffInformation', name: 'stuffInformation', component: stuffInformation, meta: { title: '人员信息' } },
            { path: '/freightClassification', name: 'freightClassification', component: freightClassification, meta: { title: '货物分类' } },
            { path: '/correspondent', name: 'correspondent', component: correspondent, meta: { title: '往来单位' } },
            { path: '/operationControl', name: 'operationControl', component: operationControl, meta: { title: '业务管理' } },
            { path: '/orderManagement', name: 'orderManagement', component: orderManagement, meta: { title: '订单管理' } },          
            { path: '/dictionaryType', name: 'dictionaryType', component: dictionaryType, meta: {title: '字典类型'}},
            { path: '/dictionaryData', name: 'dictionaryData', component: dictionaryData, meta: {title: '字典资料'}},
            { path: '/financialManagement', name: 'financialManagement', component: financialManagement, meta: {title: '财务管理'}},
            { path: '/invoiceRequest', name: 'invoiceRequest', component: invoiceRequest, meta: {title: '付款申请'}},
            { path: '/useFund', name: 'useFund', component: useFund, meta: {title: '发票申请'}},
            { path: '/expenseTemplates', name: 'expenseTemplates', component: expenseTemplates, meta: {title: '费用方案'}},
            { path: '/collectionLedger', name: 'collectionLedger', component: collectionLedger, meta: {title: '收款台账'}},
            { path: '/customerReport', name: 'customerReport', component: customerReport, meta: {title: '客户账单'}},
            { path: '/exchangeRate', name: 'exchangeRate', component: exchangeRate, meta: {title: '汇率字典'}},
            { path: '/doubleStarReport', name: 'doubleStarReport', component: doubleStarReport, meta: {title: '双星报表'}},
            { path: '/unDeliveryReport', name: 'unDeliveryReport', component: unDeliveryReport, meta: {title: '未送达报表'}},
            { path: '/singleBillReport', name: 'singleBillReport', component: singleBillReport, meta: {title: '单票利润表'}},
            { path: '/singleContainerReport', name: 'singleContainerReport', component: singleContainerReport, meta: {title: '单箱利润表'}},
            { path: '/containerFee', name: 'containerFee', component: containerFee, meta: {title: '押箱登记'}},
            // { path: '/login', name: 'login', component: Test5, meta: {title: '测试页面5'}},
            // { path: '/sweepRecord', name: 'sweepRecord', component: Test7, meta: {title: '测试页面7'}},
        ]
    },

]

const router = new VueRouter({
    routes
})

/**
 * 挂载路由守卫
 * to 代表将要访问的路径
 * from 代表从哪个路径跳转而来
 * next 是一个函数，next() 放行。   next('/login') 强制跳转
 */
router.beforeEach((to, from, next) => {
    // 加载条
    NProgress.start()

    //放行
    next()
})


// 挂载路由守卫 - 访问结束
router.afterEach(() => {
    // 关闭加载条
    NProgress.done()
})

export default router
